import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {Linear, TweenLite, TweenMax} from "gsap"
import {Emitter} from "pixi-particles";

export class TweenParticleEmitter extends PIXI.Container {
    private _emitter:Emitter;
    private _emitterConfig:any;
    private _textures:PIXI.Texture[];
    private _isDirty:boolean = true;
    public currentTime:number = 0;
    private _prevTime:number = 0;

    private _tween:TweenMax | TweenLite | null;
    private _endingTween:TweenLite | null;

    get emitterConfig():any {
        return this._emitterConfig;
    }

    constructor(textures:PIXI.Texture[], config:any) {
        super();
        this._emitterConfig = config;
        this._textures = textures;
    }

    private reset() {
        this.currentTime = 0;
        this._prevTime = 0;
    }

    private onStart() {
        this._emitter.emit = true;
    }

    private onUpdate() {
        let delta:number = Math.abs(this.currentTime - this._prevTime);
        this._emitter.update(delta);
        this._prevTime = this.currentTime;
    }

    public start(ease:any = Linear.easeNone) {
        this.stop(false);
        if(this._isDirty) {
            if(this._emitter) {
                this._emitter.destroy();
            }
            this._emitter = new Emitter(this, this._textures, this._emitterConfig);
            this._isDirty = false;
        }
        if(this._emitter.emitterLifetime === -1) {
            this._tween = new TweenMax(this, 1, {
                currentTime : 1,
                ease : Linear.easeNone,
                onStart : () => this.onStart(),
                onUpdate : () => this.onUpdate(),
                repeat : -1,
                yoyo : true
            });
        } else {
            const totalDuration = this._emitter.emitterLifetime + this._emitter.maxLifetime;
            this._tween = new TweenLite(this, totalDuration,
                {
                    currentTime : totalDuration,
                    ease : ease,
                    onStart : () => this.onStart(),
                    onUpdate : () => this.onUpdate()
                });
        }
    }

    public stop(softStop:boolean = true) {
        if(!this._emitter) {
            return;
        }

        this._emitter.emit = false;
        if(this._tween) {
            this._tween.pause();
            this._tween.kill();
        }
        this._tween = null;

        if(softStop) {
            Logger.logDev("Particle: Soft stop");
            this._endingTween = new TweenLite(this, this._emitter.maxLifetime, {
                currentTime : this._emitter.maxLifetime,
                ease : Linear.easeNone,
                onStart : () => this.reset(),
                onUpdate : () => this.onUpdate(),
                onComplete : () => {
                    Logger.logDev("Particle: onComplete");
                }
            })
        } else {
            if(this._endingTween) {
                this._endingTween.kill();
                this._endingTween = null;
            }

            this.reset();
        }
    }

    public updateConfig():void {
        this._isDirty = true;
    }
}
